import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import {showMessage} from "~/ts/vuePlugins/ShowMessagePlugin";

export default async function startWebRtcCall(username: string, video: boolean) {
    try {
        let p: OperatorApplicationApi.OperatorWebRtcStartCallOpenApiModel = {
            username,
            isVideo: video
        };
        let result = await (new OperatorApiRequest<OperatorApplicationApi.OperatorWebRtcStartCallResultOpenApiModel>({
            url: "/webrtc/startCall",
            p,
            silent: true
        })).send();
        result.showMessageOnError();
    } catch (e) {
        showMessage({
            message: e.message,
            type: "error"
        });
    }
}